/*
 * Copyright (c) 2018.  Bakos Energy (Apeldoorn NL), Spin in het Web (Apeldoorn NL)
 */

/**
 * SPIN IN HET WEB APELDOORN
 * User: Jelmer Jellema
 * Date: 12-3-2018
 * Time: 12:18
 *
 * Deze service is altijd nodig voor gebruik van sihw-angular onderdelen. Het zorgt voor algehele configuratie vanuit bijvoorbeeld localconfig
 * via de provider. Zo kan een debug-level gezet worden voor de hele library of een onderdeel, los van debuglevels in het algemeen (via de sihwlogprovider)
 * en zonder dat er in de source gerommeld moet worden (wat steeds weer commits oplevert)
 *
 * Provider:
 * loglevel('niveau'): zet algemeen loglevel voor de sihw-angular-onderdelen
 * loglevel('niveau','onderdeel'): zet voor een bepaald onderdeel een ander logleven
 *
 * Service
 * optie('onderdeel','optie','waarde'). Zet onderdeelspecifieke opties (bijv in app.js). Handig voor translations. Zie onderdelen voor mogelijkheden.
 */



angular.module('sihw.angular.config', [])
    .provider('sihwAngularConfig', function () {

        let _loglevel = 'warn'; //ons standaard loglevel
        let _perService = {}; //loglevel per servicenaam
        let _serviceOpties = {};

        //algemene setOptie-call, hooken we in provider en server
        /**
         * Zet een optie voor een servicenaam.
         * @param servicenaam
         * @param optie
         * @param waarde
         */
        function _optie(servicenaam,optie,waarde) {
            let opties = _serviceOpties[servicenaam] || {};
            opties[optie] = waarde;
            _serviceOpties[servicenaam] = opties;
        }

        //PROVIDER sihwAngularConfigProvider
        return {
            /**
             * Set het logleven voor alle services of een specifieke
             * @param {string} sLoglevel
             * @param {string} [servicenaam] servicenaam waarvoor het loglevel wordt overschreven
             */
            loglevel(sLoglevel, servicenaam) {
                if (!servicenaam) {
                    _loglevel = sLoglevel;
                }
                else {
                    _perService[servicenaam] = sLoglevel;
                }
                return this; //chaining
            },

            //zet een optie, zie algemene call. Chainable
            optie(servicenaam,optie,waarde)
            {
                _optie(servicenaam,optie,waarde);
                return this;
            },

            //de service:
            $get: ['$rootScope',function ($rootScope) {
                console.log('sihw-angular library (c) 2018 Spin in het Web BV / Jellybean BV');
                return {
                    /**
                     * Return het algemene loglevel of een loglevel voor een specifieke service
                     * @param {string} [servicenaam]
                     */
                    loglevel(servicenaam) {
                        return ((servicenaam && _perService[servicenaam]) || _loglevel);
                    },

                    //zet een optie, zie algemene call
                    optie(servicenaam,optie,waarde)
                    {
                        _optie(servicenaam,optie,waarde);
                        return this;
                    },

                    opties(servicenaam)
                    {
                        return _serviceOpties[servicenaam] || {};
                    }
                }
            }]
        };
    });

